<template>
    <div class="input-block" :class="inputValue && inputValue.length >= 2 ? 'has-value' : ''">
        <label class="label">{{ labelName }}</label>
        <div class="dropdown">
            <input
                v-if="Object.keys(selectedItem).length === 0"
                ref="dropdowninput"
                v-model.trim="inputValue"
                @input="getList"
                class="dropdown-input"
                type="text"
                :placeholder="placeholder"
            />
            <div v-else @click="resetSelection" class="dropdown-selected">
                <div class="item-first">{{ selectedItem.city.toUpperCase() }}</div>
                <div class="item-second">{{ selectedItem.iata_code }}</div>
            </div>
            <img
                src="../../../../../../assets/main_images/top-bottom-icon.png"
                class="top-bottom-arrow"
                :class="inputValue && apiLoaded ? 'top-arrow' : ''"
            />
            <div v-show="inputValue && apiLoaded" class="dropdown-list">
                <div @click="selectItem(item)" v-for="(item, i) in itemList" :key="i" class="dropdown-item">
                    <div class="item-first" v-if="item.city && item.name">
                        <div class="item-title">{{ item.city }}</div>
                        <div class="item-subtitle">{{ item.name }}</div>
                    </div>
                    <div v-else>{{ item.message }}</div>
                    <div class="item-second">{{ item.iata_code }}</div>
                </div>
            </div>
        </div>
        <div class="error-message" v-if="error">{{ error }}</div>
    </div>
</template>

<script>
import axios from 'axios'
import { debounce as _debounce } from 'lodash'

export default {
    name: 'AirportsSearchSelector',
    props: ['placeholder', 'labelName', 'error'],
    data() {
        return {
            selectedItem: {},
            inputValue: '',
            seenItemsByCode: {},
            itemList: [],
            apiLoaded: false,
            apiUrl: this.$globalConfig.api.base() + 'a/airports/autocomplete',
        }
    },
    watch: {
        itemList(n) {
            const newItems = []
            for (const item of n) {
                if (!this.seenItemsByCode[item.iata_code]) {
                    newItems.push(item)
                    this.$set(this.seenItemsByCode, item.iata_code, item)
                }
            }

            if (newItems.length) {
                this.sendAnalyticsEventImpressions(newItems)
            }
        },
    },
    mounted() {
        this.getList()
        window.addEventListener('click', (e) => {
            const iIstatement = e.target.className.includes('dropdown-item')
            const sIstatement = e.target.className.includes('dropdown-list')
            const thIstatement = e.target.className.includes('dropdown-input')
            if (!(iIstatement || sIstatement || thIstatement) && this.inputValue && this.apiLoaded) {
                e.stopPropagation()
                if (Object.keys(this.selectedItem).length === 0) {
                    this.inputValue = ''
                }
            } else {
                e.stopPropagation()
            }
        })
    },
    methods: {
        resetSelection() {
            this.selectedItem = {}
            this.$nextTick(() => this.$refs.dropdowninput.focus())
            this.$emit('input')
        },
        selectItem(theItem) {
            this.selectedItem = theItem
            this.inputValue = ''
            this.$emit('input', theItem)
        },
        getList: _debounce(function () {
            const params = new URLSearchParams()
            if (this.inputValue && this.inputValue.length > 2) {
                params.append('q', this.inputValue)
                axios.get(this.apiUrl, { params }).then((response) => {
                    if (response && response.data && response.data.length > 0) {
                        this.itemList = response.data
                        this.apiLoaded = true
                    } else {
                        this.itemList = []
                    }
                })
            }
        }, 600),
        sendAnalyticsEventImpressions(items) {
            this.$gtm.trackEcommerceEvent(
                {
                    impressions: {
                        products: items.map((item) => ({
                            name: item.iata_code,
                            id: item.iata_code.toLowerCase(),
                            dimension4: this.tripType, // trip_type
                            list: 'Airport autocomplete ' + this.labelKey + ' ' + this.tripType,
                        })),
                    },
                },
                'Product Impressions',
                true
            )
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/scss/global-styles';

.input-block {
    padding: 10px 20px;
    flex-basis: 25%;
    position: relative;

    &:hover,
    &:active,
    &.has-value {
        background: rgba(192, 192, 201, 0.12) 0% 0% no-repeat padding-box;
        border-radius: 6px;
    }

    .label {
        font-family: 'Gilroy-Regular', sans-serif;
        font-size: 12px;
        line-height: 14px;
        text-align: left;
        color: $mainTextBlueColor;
    }

    .dropdown {
        position: relative;
        width: 100%;
        margin: 0;

        .top-bottom-arrow {
            width: 11px;
            max-height: 10px;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            color: $mainTextBlueColor;

            &.top-arrow {
                transform: rotate(180deg);
            }
        }

        .dropdown-input {
            width: 100%;
            background: transparent;
            outline: none;
            padding: 10px 10px 10px 0;
            cursor: pointer;
            font-family: 'Gilroy-SemiBold', sans-serif;
            font-size: 18px;
            line-height: 22px;
            text-align: left;
            color: $mainTextBlueColor;
            border: none;
        }

        .dropdown-input::placeholder {
            font-family: 'Gilroy-SemiBold', sans-serif;
            font-size: 18px;
            line-height: 22px;
            text-align: left;
            color: $mainTextBlueColor;
        }

        .dropdown-list {
            position: absolute;
            top: 36px;
            left: 0;
            overflow-y: scroll;
            max-height: 250px;
            width: calc(100% + 32px);
            color: $mainTextBlueColor;
            padding: 10px 0 10px 0;
            margin-left: -16px;
            border: 0.5px solid #ffffff27;
            border-radius: 7px;
            z-index: 1001;
            background: #f5f5f6;

            &::-webkit-scrollbar {
                width: 5px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: rgba(1, 1, 83, 0.05);
                border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background-color: rgba(1, 1, 83, 0.1);
            }
        }

        .dropdown-selected {
            padding: 10px 20px 10px 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            font-family: 'Gilroy-SemiBold', sans-serif;
            font-size: 18px;
            line-height: 22px;
            text-align: left;
            color: $mainTextBlueColor;
            border: none;

            .item-second {
                color: $mainTextBlueColor;
            }
        }

        .dropdown-item {
            padding: 10px;

            &:hover {
                background-color: rgba(1, 1, 83, 0.05);
            }
        }

        .dropdown-item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            font-family: 'Gilroy-Regular', sans-serif;
            font-size: 16px;
            line-height: 20px;
            text-align: left;
            color: $mainTextBlueColor;
            border: none;

            .item-first {
                .item-title {
                    font-size: 14px;
                    line-height: 14px;
                    color: $mainTextBlueColor;
                }

                .item-subtitle {
                    font-size: 12px;
                    line-height: 14px;
                }
            }

            .item-second {
                color: $mainTextBlueColor;
            }
        }

        /*.dropdown-item-flag {*/
        /*  max-width: 24px;*/
        /*  max-height: 18px;*/
        /*  margin: auto 12px auto 0px;*/
        /*}*/
    }

    .error-message {
        font-family: 'Gilroy-SemiBold', sans-serif;
        font-size: 12px;
        line-height: 12px;
        letter-spacing: 0.4px;
        color: $mainErrorColor;
        position: absolute;
        bottom: 0;
        left: 16px;
        animation-name: errorHandle;
        animation-duration: 0.5s;
    }

    @keyframes errorHandle {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
}

@media (max-width: 768px) {
    .input-block {
        max-width: unset;
        padding: 10px 10px 20px;
        flex-basis: unset;
        width: 100%;

        .label {
            font-size: 14px;
            line-height: 17px;
        }

        .dropdown {
            width: 100%;
            max-width: unset;

            .dropdown-input {
                font-size: 16px;
                line-height: 20px;
            }

            .dropdown-input::placeholder {
                font-size: 16px;
                line-height: 20px;
            }

            .dropdown-list {
                width: calc(100% + 22px);
                margin-left: -11px;
            }

            .dropdown-selected {
                display: flex;
                flex-direction: column-reverse;

                .item-first {
                    font-size: 12px;
                    line-height: 16px;
                    text-align: center;
                }

                .item-second {
                    padding-bottom: 5px;
                    color: $mainTextBlueColor;
                }
            }

            .dropdown-item {
                display: flex;
                flex-direction: column-reverse;
                border-bottom: 0.3px solid rgba(255, 255, 255, 0.33);

                &:last-child {
                    border: none;
                }

                .item-first {
                    text-align: center;

                    .item-title {
                    }

                    .item-subtitle {
                        display: none;
                    }
                }
            }
        }

        .error-message {
            left: 11px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/shared/forms_entities/form-fields/AirportsSearchSelector.vue